import { Box, Typography } from "@mui/material";
import { colorsFoundation } from "../../../theme/index.js";
import { getDatumZeit, getEuro } from "../../../services/formatService.js";

const ListContainer = ({ children }) => {
  return (
    <Box
      sx={{
        overflow: "hidden",
      }}
    >
      {children}
    </Box>
  );
};

const PaymentMatchListItem = ({ pm, isSelected, onToggle }) => {
  const payment = pm?.payment;

  if (!payment) {
    return null;
  }

  return (
    <ListItem
      selected={isSelected}
      onClick={onToggle ? () => onToggle(payment.id) : undefined}
    >
      <Box
        sx={{
          display: "flex",
          gap: 2,
          opacity: isSelected ? 1 : 0.5,
        }}
      >
        <Box sx={{ pt: 0.5 }}>
          <input type="checkbox" readOnly checked={isSelected} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 1,
            }}
          >
            <Box
              component="span"
              sx={{
                px: 1,
                py: 0.25,
                borderRadius: 999,
                fontSize: "0.75rem",
                backgroundColor:
                  pm.status === "exact"
                    ? colorsFoundation.key.gold[50]
                    : colorsFoundation.status.critical[50],
                color:
                  pm.status === "exact"
                    ? colorsFoundation.key.gold[700]
                    : colorsFoundation.status.critical[700],
              }}
            >
              {pm.status === "exact" ? "Exakt" : "Möglich"}
            </Box>
          </Box>
          <Typography variant="caption" color="text.secondary">
            {payment.remitter}
          </Typography>
          <Typography variant="body2">{payment.description}</Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 1,
              alignItems: "center",
            }}
          >
            <Typography variant="caption" color="text.secondary">
              Datum: {getDatumZeit(payment.processed_at)}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color:
                  payment.debit_credit === "C" ? "success.main" : "error.main",
              }}
            >
              {payment.debit_credit === "C" ? "" : "-"}
              {getEuro(payment.amount)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </ListItem>
  );
};

const ListItem = ({ selected = false, onClick, children }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        p: 2,
        borderBottom: `1px solid ${colorsFoundation.neutral[200]}`,
        cursor: onClick ? "pointer" : "default",
        backgroundColor: selected ? colorsFoundation.neutral[50] : "white",
        "&:hover": {
          backgroundColor: selected
            ? colorsFoundation.neutral[50]
            : colorsFoundation.neutral[100],
        },
      }}
    >
      {children}
    </Box>
  );
};

export { ListContainer, ListItem, PaymentMatchListItem };
